import * as XLSX from 'xlsx';
import { getProgramacaoHavanColumns, getVxEstado } from '../components/tanStackColumns';
import { tituloDaLinha } from '../components/ProgramacaoHavanTable';
import { aplicarLayoutColunas } from './layoutColunas';

const simOuNao = valor => (valor ? 'Sim' : 'Não');

const descreverVx = registro => {
  if (!registro.vx_consultada) return 'Não consultada';
  const estado = getVxEstado(registro);
  if (estado === 'valida') return registro.vx_status || 'Válida';
  if (estado === 'andamento') return registro.vx_status || 'Pesquisa em análise';
  return registro.vx_status ? `${registro.vx_status} (consultar de novo)` : 'Consultar de novo';
};

// Colunas que na tela são botões/ícones: no Excel viram texto.
const VALORES_EM_TEXTO = {
  terceiro: registro => simOuNao(registro.terceiro),
  protocolo: registro => simOuNao(registro.protocolo),
  vx: descreverVx,
  gestor: registro => [registro.gestor_nome, registro.gestor_telefone].filter(Boolean).join(' · ')
};

// Mesmo texto que o botão de copiar da célula usa (datas dd/mm/aaaa, carreta "FROTA / PLACA"...).
export const valorDaColuna = (coluna, registro) => {
  const emTexto = VALORES_EM_TEXTO[coluna.id];
  if (emTexto) return emTexto(registro);
  const getValue = () => (coluna.accessorFn ? coluna.accessorFn(registro) : registro?.[coluna.accessorKey]);
  const valor = coluna.copyValue ? coluna.copyValue({ row: { original: registro }, getValue }) : getValue();
  return valor ?? '';
};

// A cor da linha não vai para o Excel: a última coluna diz o que ela queria dizer (cancelada, protocolo, pendências...).
const situacaoDaLinha = registro => (tituloDaLinha(registro) || '').replace(/^Carga /, '');

export const montarLinhas = (registros, colunas, turno = null) => [
  [...(turno ? ['Turno'] : []), ...colunas.map(coluna => coluna.header), 'Situação'],
  ...registros.map(registro => [
    ...(turno ? [turno(registro)] : []),
    ...colunas.map(coluna => valorDaColuna(coluna, registro)),
    situacaoDaLinha(registro)
  ])
];

const larguras = linhas => linhas[0].map((_, indice) => ({
  wch: Math.min(60, Math.max(8, ...linhas.map(linha => String(linha[indice] ?? '').length + 2)))
}));

const TURNOS = [['primeiro', '1º turno'], ['segundo', '2º turno']];

const adicionarAba = (pasta, nome, linhas) => {
  const aba = XLSX.utils.aoa_to_sheet(linhas);
  aba['!cols'] = larguras(linhas);
  XLSX.utils.book_append_sheet(pasta, aba, nome);
};

/**
 * Dia inteiro (sem os filtros da tela), com as colunas visíveis na ordem configurada: a primeira aba junta os dois
 * turnos (coluna Turno) e depois vem uma aba por turno. Retorna o nome do arquivo gerado.
 */
export const exportarProgramacaoDoDia = ({ dataProgramacao, turnos, layoutColunas }) => {
  const colunas = aplicarLayoutColunas(getProgramacaoHavanColumns(), layoutColunas);
  const pasta = XLSX.utils.book_new();
  const doTurno = chave => (turnos?.[chave]?.registros || []).map(registro => ({ ...registro, turno: chave }));
  const nomeDoTurno = Object.fromEntries(TURNOS);
  const doDia = TURNOS.flatMap(([chave]) => doTurno(chave));
  adicionarAba(pasta, 'Dia completo', montarLinhas(doDia, colunas, registro => nomeDoTurno[registro.turno]));
  TURNOS.forEach(([chave, nomeAba]) => adicionarAba(pasta, nomeAba, montarLinhas(doTurno(chave), colunas)));
  const nomeArquivo = `programacao-havan-${String(dataProgramacao || '').slice(0, 10)}.xlsx`;
  XLSX.writeFile(pasta, nomeArquivo);
  return nomeArquivo;
};
